import { Button } from '@/components/ui/button'
import { useCnpjLookup } from '../hooks/use-cnpj-lookup'
import { useClientContext } from '@/context/client'
import { CNPJInput } from '@/components/form/input'
import Spinner from '@/components/ui/spinner'
import { useForm } from 'react-hook-form'
import { zodResolver } from '@hookform/resolvers/zod'
import * as z from 'zod'
import { Form, FormField, FormItem, FormLabel, FormControl, FormMessage } from '@/components/ui/form'
import { useToast } from '@/lib/hooks/use-toast'
import { isAxiosError } from 'axios'

const CNPJSchema = z.object({
  cnpj: z.string().min(1, { message: 'CNPJ obrigatório' })
})

type CNPJFormData = z.infer<typeof CNPJSchema>

export function CnpjSearchForm() {
  const { toast } = useToast()
  const { cnpj, setCnpj, carregando } = useClientContext()
  const { handleSubmit } = useCnpjLookup()
  const form = useForm({
    resolver: zodResolver(CNPJSchema),
    defaultValues: {
      cnpj: cnpj
    }
  })

  const onSubmit = async (data: CNPJFormData) => {
    try {
      await handleSubmit(data.cnpj)
      setCnpj(data.cnpj)
    } catch (err) {
      console.error(err)
      let message = 'Erro inesperado'
      if (isAxiosError(err) && err.response) {
        message = err.response.data.message
      }
      toast({
        variant: 'destructive',
        description: message
      })
    }
  }

  return (
    <Form {...form}>
      <form onSubmit={form.handleSubmit(onSubmit)}>
        <h2 className="text-xl font-bold text-center">Consulta de CNPJ</h2>
        <div
          className={`max-w-fit mx-auto flex gap-2 ${form.getFieldState('cnpj').error ? 'items-center' : 'items-end'}`}
        >
          <FormField
            control={form.control}
            name="cnpj"
            render={({ field }) => (
              <FormItem className="flex-1">
                <FormLabel>CNPJ</FormLabel>
                <FormControl>
                  <CNPJInput {...field} />
                </FormControl>
                <FormMessage />
              </FormItem>
            )}
          />
          <Button
            className="bg-primary hover:bg-primary-hover text-primary-foreground"
            type="submit"
            disabled={carregando}
          >
            {carregando ? (
              <div className="flex items-center gap-2">
                Buscando...
                <Spinner />
              </div>
            ) : (
              'Buscar'
            )}
          </Button>
        </div>
      </form>
    </Form>
  )
}
